var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43512 2.71484C4.92857 2.71484 2.08594 5.61016 2.08594 9.18172C2.08594 12.7533 4.92857 15.6486 8.43512 15.6486C9.90235 15.6486 11.2533 15.1417 12.3285 14.2904L16.6041 18.6453C16.914 18.961 17.4165 18.961 17.7264 18.6453C18.0364 18.3296 18.0364 17.8178 17.7264 17.5021L13.4509 13.1473C14.2866 12.0522 14.7843 10.6761 14.7843 9.18172C14.7843 5.61016 11.9417 2.71484 8.43512 2.71484ZM3.67323 9.18172C3.67323 6.50305 5.8052 4.33156 8.43512 4.33156C11.065 4.33156 13.197 6.50305 13.197 9.18172C13.197 11.8604 11.065 14.0319 8.43512 14.0319C5.8052 14.0319 3.67323 11.8604 3.67323 9.18172Z",
    fill: "url(#paint0_linear_17251_21141)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9319 0.79101L18.4274 2.10313C18.508 2.31651 18.5482 2.4232 18.6109 2.51294C18.6664 2.59247 18.7347 2.66197 18.8127 2.71852C18.9008 2.78233 19.0056 2.82337 19.2151 2.90543L20.5033 3.4101L19.2151 3.91476C19.0056 3.99683 18.9008 4.03786 18.8127 4.10167C18.7347 4.15823 18.6664 4.22772 18.6109 4.30725C18.5482 4.39699 18.508 4.50368 18.4274 4.71706L17.9319 6.02918L17.4364 4.71706C17.3559 4.50368 17.3156 4.39699 17.2529 4.30725C17.1974 4.22772 17.1292 4.15823 17.0511 4.10167C16.963 4.03786 16.8582 3.99683 16.6487 3.91476L15.3605 3.4101L16.6487 2.90543C16.8582 2.82337 16.963 2.78233 17.0511 2.71852C17.1292 2.66197 17.1974 2.59247 17.2529 2.51294C17.3156 2.4232 17.3559 2.31651 17.4364 2.10313L17.9319 0.79101Z",
    fill: "url(#paint1_linear_17251_21141)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5033 6.32019V4.86514M15.5033 1.95505V0.5M14.7891 1.22752H16.2176M14.7891 5.59267H16.2176M17.9319 0.79101L17.4364 2.10313C17.3559 2.31651 17.3156 2.4232 17.2529 2.51294C17.1974 2.59247 17.1292 2.66197 17.0511 2.71852C16.963 2.78233 16.8582 2.82337 16.6487 2.90543L15.3605 3.4101L16.6487 3.91476C16.8582 3.99683 16.963 4.03786 17.0511 4.10167C17.1292 4.15823 17.1974 4.22772 17.2529 4.30725C17.3156 4.39699 17.3559 4.50368 17.4364 4.71706L17.9319 6.02918L18.4274 4.71706C18.508 4.50368 18.5482 4.39699 18.6109 4.30725C18.6664 4.22772 18.7347 4.15823 18.8127 4.10167C18.9008 4.03786 19.0056 3.99683 19.2151 3.91476L20.5033 3.4101L19.2151 2.90543C19.0056 2.82337 18.9008 2.78233 18.8127 2.71852C18.7347 2.66197 18.6664 2.59247 18.6109 2.51294C18.5482 2.4232 18.508 2.31651 18.4274 2.10313L17.9319 0.79101Z",
    stroke: "url(#paint2_linear_17251_21141)",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17251_21141",
    x1: 19.2358,
    y1: -2.94368,
    x2: -0.985415,
    y2: 26.9051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281884,
    stopColor: "#60E25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499787,
    stopColor: "#6123E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5AC3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#22FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17251_21141",
    x1: 19.5319,
    y1: 0.267185,
    x2: 15.1374,
    y2: 6.65271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#7745E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#60E25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5AC3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#22FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17251_21141",
    x1: 19.5319,
    y1: 0.267185,
    x2: 15.1374,
    y2: 6.65271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#7745E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#60E25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5AC3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#22FFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSearchIcon);
export default __webpack_public_path__ + "static/media/AiSearchIcon.3dff896b410d4e92985824c014a2e34d.svg";
export { ForwardRef as ReactComponent };